import React, { useMemo } from 'react';
import { MarkdownInline } from './MarkdownInline';
import DataTable, { Column } from '../../../../components/shared/DataTable';

interface TableBlockProps {
    lines: string[];
}

export const TableBlock: React.FC<TableBlockProps> = ({ lines }) => {
    try {
        // Parse markdown table rows
        const rows = lines
            .filter(line => line.trim().startsWith('|'))
            .map(line => {
                const content = line.trim();
                const cells = content.split('|').map(c => c.trim()).filter((_, idx, arr) => idx > 0 && idx < arr.length - 1);
                return cells;
            });

        if (rows.length < 2) return null;

        const headerLabels = rows[0];
        const dataRows = rows.slice(2);

        // Create columns dynamically based on header labels
        const columns: Column<any>[] = useMemo(() => {
            return headerLabels.map((label, index) => ({
                key: `col-${index}`,
                header: <MarkdownInline text={label} />,
                render: (row: any) => <MarkdownInline text={row[`col-${index}`] || '-'} />
            }));
        }, [headerLabels]);

        // Transform data rows into objects with dynamic keys
        const data = useMemo(() => {
            return dataRows.map((row, rowIndex) => {
                const rowData: any = { id: `row-${rowIndex}` };
                row.forEach((cell, cellIndex) => {
                    rowData[`col-${cellIndex}`] = cell;
                });
                return rowData;
            });
        }, [dataRows]);

        return (
            <div className="my-s6 w-full">
                <div className="overflow-hidden rounded-lg border border-subtle shadow-xs">
                    <DataTable
                        columns={columns}
                        data={data}
                        getRowKey={(row) => row.id}
                        emptyMessage="Sem dados na tabela."
                    />
                </div>
            </div>
        );
    } catch (e) {
        return <pre className="text-sm text-danger-text">Erro ao renderizar tabela</pre>;
    }
};
